import { PermissionsData } from 'modules/authenticate/interfaces';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';

interface OwnProps {
  value: keyof PermissionsData | Array<keyof PermissionsData>;
  children: any;
  permissions?: PermissionsData;
  fallback?: any;
}

const ValidPermission = ({
  children,
  permissions,
  value,
  fallback = null,
}: OwnProps) => {
  const values = typeof value === 'string' ? [value] : value;
  const hasPermission = !!permissions && values.some(val => permissions[val]);

  return hasPermission ? children : fallback;
};

const mapStateToProps = ({ authenticate: { data } }: ApplicationState) => ({
  permissions: data?.permissions,
});

export default connect(mapStateToProps)(ValidPermission);
